import React, { Component } from 'react'
import AlertModalManager from './alert-modal-manager'
import { AlertModal } from '../alert-modal/AlertModal'
import { saveSessionEnd } from '../../services/Metrics'

class AlertModalContainer extends Component {

  state = {
    content: null,
    open: false,
    onCloseHandler: null,
    closeOnDimmerClick: false
  }

  componentWillMount = () => AlertModalManager.addListener('open', this.openHandler)

  componentWillUnmount = () => AlertModalManager.remove('open', this.openHandler)

  openHandler = (args) => {
    this.setState({ content: args.content, open: true, onCloseHandler: args.onCloseHandler, closeOnDimmerClick: args.closeOnDimmerClick })
  }

  onCloseHandler = () => {
    this.setState({ open: false })
    this.state.onCloseHandler && this.state.onCloseHandler()
  }

  render() {
    const { content, open, onCloseHandler } = this.state
    return (
      <AlertModal
        isOpen={open}
        message={content ? content.message : ""}
        title={content ? content.title : ""}
        buttonLabel='OK'
        handleClick={onCloseHandler ?
          this.onCloseHandler :
          () => {
            saveSessionEnd()
            window.location.href = "/"
          }
        }
      />
    )
  }
}

export default AlertModalContainer

